import Link from "next/link";
import { IconContainer } from "./styles.ts";
import { DynamicIconProps } from "@template/components/DynamicIcon";
import { DynamicIcon } from "@template/components";

type TIconLinkProps = {
  name: string;
  url?: string;
} & DynamicIconProps;

export interface IIconGroupProps {
  icons: TIconLinkProps[];
  compact?: boolean;
}

export const IconGroup = ({ icons, compact }: IIconGroupProps) => {
  const Icon = ({ name, ...props }: TIconLinkProps) => {
    return (
      <DynamicIcon
        name={name}
        {...props}
      />
    );
  };
  return (
    <IconContainer $compact={compact}>
      {icons?.map((icon, i) =>
        icon.url ? (
          <Link
            href={icon.url}
            key={i}
            title={`Link to Yay.com ${icon.name} account`}
          >
            <Icon
              name={icon.name}
              {...icon}
            />
          </Link>
        ) : (
          <Icon
            name={icon.name}
            {...icon}
            key={i}
          />
        )
      )}
    </IconContainer>
  );
};
